import DashboardPage from '@portal/features/dashboard/DashboardPage'
import { Header } from '@portal/features/navigation/Header'
import MainMenu from '@portal/features/navigation/MainMenu'
import MainTabs from '@portal/features/navigation/MainTabs'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => (
  <>
    <Header.Left>
      <MainMenu />
    </Header.Left>
    <Header.Center>
      <MainTabs value="dashboard" />
    </Header.Center>
    <DashboardPage />
  </>
)

export const Route = createFileRoute('/_app/dashboard')({
  component: RouteComponent,
})
